import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX, FiLink } from 'react-icons/fi';
import useRequest from '../../../hooks/useRequest';

function EditBrokerPopup({ isOpen, onClose, onSuccess, broker }) {
  const [fbLink, setFbLink] = useState(broker?.fb_link || '');
  const [error, setError] = useState(null);
  const { sendRequest, loading } = useRequest();

  useEffect(() => {
    if (broker) {
      setFbLink(broker.fb_link || '');
    }
  }, [broker]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const userData = JSON.parse(localStorage.getItem('userData'));
      if (!userData?.company) {
        throw new Error('Company ID not found');
      }

      await sendRequest('PATCH', `/api/broker/?id=${broker.id}`, {
        fb_link: fbLink,
        company: userData.company
      });

      onSuccess();
      onClose();
    } catch (error) {
      console.error('Failed to update broker:', error);
      setError(error.message || 'Failed to update broker');
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-white rounded-xl p-6 w-full max-w-md relative"
          >
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <FiX className="w-5 h-5" />
            </button>

            <h2 className="text-xl font-semibold text-gray-800 mb-4">Edit Broker</h2>

            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Facebook Link
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FiLink className="h-5 w-5 text-gray-400" />
                  </div>
                  <input
                    type="text"
                    value={fbLink}
                    onChange={(e) => setFbLink(e.target.value)}
                    placeholder="Enter Facebook profile link"
                    className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                    required
                  />
                </div>
              </div>

              {error && (
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="mb-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm"
                >
                  {error}
                </motion.div>
              )}

              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={onClose}
                  className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? 'Updating...' : 'Update'}
                </button>
              </div>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default EditBrokerPopup; 